import { ComponentProps } from 'react';
import { css } from '@emotion/react';
import { theme } from '@frontend/theme';
import { Modal, useResponsiveModal } from '@frontend/design-system';

type ModalFooterProps = ComponentProps<typeof Modal.Footer>;
type ModalActionsProps = ComponentProps<typeof Modal.Actions>;

export const ResponsiveModalFooter = ({ ...props }: ModalFooterProps) => {
  const { isResponsiveMode } = useResponsiveModal();
  return <Modal.Footer css={styles.footer(isResponsiveMode)} {...props} />;
};

/**
 * @deprecated use ResponsiveModalFooter instead
 */
export const ResponsiveModalActions = ({ ...props }: ModalActionsProps) => {
  const { isResponsiveMode } = useResponsiveModal();
  return <Modal.Actions css={styles.footer(isResponsiveMode)} {...props} />;
};

export const styles = {
  footer: (isResponsiveModal = false) =>
    isResponsiveModal &&
    css({
      padding: theme.spacing(2),
      boxShadow: theme.shadows.floating,
      gap: theme.spacing(1.25),
      display: 'flex',
      flexDirection: 'column-reverse',
      flexWrap: 'wrap',
      justifyContent: 'flex-end',
    }),
};
